import React from 'react';

import {useSubmitHandover} from '../../hooks/useSubmitHandover';
import {Panel} from '../../components/Panel/Panel';
import {ScrollableModal} from '../../components/Common/ScrollableModal';
import {useDjangoContext} from '../../contexts/useAuthContext';
import {HandoverSFPNonPADModal} from './HandoverSFPNonPADModal';
import {hasPermission} from '../../contexts/FeatureBoundary';
import {HandoverRelationshipManagerModals} from './HandoverRelationshipManagerModals';
import {GlobalPermissionEnum} from '../../schema-types/globalTypes';
import {HandoverJuniorAdviserModals} from './HandoverJuniorAdviserModals';
import {HandoverSeniorAdviserSignOffModal} from './HandoverSeniorAdviserSignOffModal';
import {useReviewContext} from '../../contexts/ReviewContext';
import {HandoverSeniorAdviserSubmitModal} from './HandoverSeniorAdviserSubmitModal';

interface HandoverSubmitModalProps {
  isOpen: boolean;
  close: () => void;
}

export const HandoverSubmitModal: React.FC<HandoverSubmitModalProps> = ({
  isOpen,
  close,
}) => {
  const {submissionStatus} = useSubmitHandover();

  return (
    <>
      <ScrollableModal size="small" open={submissionStatus === 'submitting'}>
        <Panel title="Submitting handover">
          Please do not refresh the page or re-submit.
        </Panel>
      </ScrollableModal>
      <ScrollableModal autoHeight onClose={() => close()} size="large" open={isOpen}>
        <ModalSubmitScreens onClose={() => close()} />
      </ScrollableModal>
    </>
  );
};

const ModalSubmitScreens: React.FC<{onClose: () => void}> = ({onClose}) => {
  const {djangoUser} = useDjangoContext();
  const {reviewValidation} = useReviewContext();
  if (
    hasPermission(djangoUser, [
      GlobalPermissionEnum.can_access_pad_relationship_manager_handover_modal_FE,
    ])
  ) {
    return <HandoverRelationshipManagerModals onClose={onClose} />;
  }
  if (
    hasPermission(djangoUser, [
      GlobalPermissionEnum.can_access_pad_junior_handover_modal_FE,
    ])
  ) {
    return <HandoverJuniorAdviserModals onClose={onClose} />;
  }
  if (
    hasPermission(djangoUser, [
      GlobalPermissionEnum.can_access_pad_senior_handover_modal_FE,
    ])
  ) {
    if (reviewValidation?.sendForSignoff) {
      // fixing ON-6493 Qualified PAD user unable to soft submit
      return <HandoverSeniorAdviserSignOffModal onClose={onClose} />;
    }
    return <HandoverSeniorAdviserSubmitModal onClose={onClose} />;
  }
  return <HandoverSFPNonPADModal onClose={onClose} />;
};
